import React, { createContext, useContext, useState ,useEffect} from "react";

const ChatContext = createContext();

export const ChatProvider = ({ children }) => {
const [titleId, setTitleId] = useState(null);
// const [initialStart, setInitialStart] = useState(false); // Add this line
  const [initialStart, setInitialStart] = useState(() => JSON.parse(localStorage.getItem("initialStart")) || false);

const [sidelistUpdate, setSidelistUpdate] = useState(); // Add this line
const [checkType, setCheckType] = useState(); // Add this line
const [shareSize, setShareSize] = useState(); // Add this line
const [highLightBtn,setHighLightBtn]=useState()
const [conversationHistory, setConversationHistory] = useState([]);

  useEffect(() => {
    localStorage.setItem("initialStart", JSON.stringify(initialStart));
  }, [initialStart]);

  useEffect(() => {
      const savedValue = localStorage.getItem("highlightedButton");
      // console.log(savedValue,"savedValuesavedValue")
      if (savedValue) {
          setHighLightBtn(savedValue);
      }
  }, []);
  

  return (
    <ChatContext.Provider value={{ titleId, setTitleId ,initialStart, setInitialStart,sidelistUpdate, setSidelistUpdate,checkType,setCheckType,shareSize,setShareSize,highLightBtn,setHighLightBtn,conversationHistory,setConversationHistory}}>
      {children}
    </ChatContext.Provider>
  );
};

export const useChatContext = () => useContext(ChatContext);
